module.exports = __webpack_public_path__ + "img/bg.c7443fdc.jpg";